import React, { useState, useEffect, useRef } from "react";
import apiService from "../../../Common/Configurations/APIService";
import config from "../../../Common/Configurations/APIConfig";

const GroupTourChat = ({ tour, user, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);
  const senderType = "Support";

  const fetchChat = async () => {
    try {
      const res = await apiService.getAll(`${config.GETGROUPTOURCHATBYID}?groupTourId=${tour.groupTourId}`);
      if (res?.messages) setMessages(res.messages);
    } catch (err) { console.error("Admin GroupTour chat error", err); }
  };

  useEffect(() => { if (tour?.groupTourId) fetchChat(); }, [tour?.groupTourId]);

  useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    setLoading(true);
    const payload = {
      senderId: user.id,
      senderName: user.name || "Travel Support",
      senderType: "Support", 
      content: newMessage,
      attachments: []
    };
    try {
      await apiService.create(`${config.SENDGROUPTOURMESSAGE}?groupTourId=${tour.groupTourId}`, payload);
      setNewMessage("");
      fetchChat();
    } catch (err) { console.error("Send error", err); } finally { setLoading(false); }
  };

  return (
        <div className="card shadow-lg border-0 h-100" style={{ minHeight: '550px', display: 'flex', flexDirection: 'column' }}>
        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center py-3">
        <h6 className="mb-0 text-white fw-bold"><i className="ri-customer-service-2-line me-2"></i> Client: {tour.companyName}</h6>
       <div className="d-flex align-items-center gap-2">
            <span className="badge bg-soft-light text-white border border-light-subtle fs-10">{user?.name}</span>
            <button className="btn btn-close btn-close-white" onClick={onClose}></button>
        </div>
      </div>
      <div className="card-body p-3 bg-light" style={{ flex: 1, overflowY: "auto" }}>
        {messages.map((msg, i) => (
          <div key={i} className={`d-flex mb-3 ${msg.senderType === senderType ? "justify-content-end" : "justify-content-start"}`}>
            <div className={`p-2 px-3 rounded-3 shadow-sm ${msg.senderType === senderType ? "bg-primary text-white" : "bg-white text-dark border"}`} style={{ maxWidth: "85%", fontSize: "13px" }}>
              <div className="fw-bold small mb-1 opacity-75">{msg.senderType === senderType ? `You (${user.name})` : msg.senderName}</div>
              <div>{msg.content}</div>
              <div className="text-end mt-1 small opacity-50" style={{ fontSize: "9px" }}>{new Date(msg.sentAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
            </div>
          </div>
        ))}
        <div ref={scrollRef} />
      </div>
      <div className="card-footer bg-white p-3">
        <form onSubmit={handleSendMessage} className="d-flex gap-2">
          <input type="text" className="form-control" placeholder="Reply to client..." value={newMessage} onChange={(e) => setNewMessage(e.target.value)} disabled={loading} />
          <button className="btn btn-primary" type="submit" disabled={loading || !newMessage.trim()}>
            {loading ? <span className="spinner-border spinner-border-sm"></span> : <i className="ri-send-plane-2-fill"></i>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GroupTourChat;